import { DatePipe } from '@angular/common';
import { NOON_UTC_OFFSET_MS } from './constants';

const datePipe = new DatePipe('en-US');

// Preserve the exact original timestamp for unchanged date fields.
// For user-changed dates (formatted as yyyy-MM-dd by DatePipe), add 12h for noon UTC.
export function dateToTimestamp(current: string | null, rawApiValue: any): number {
  if (!current) return 0;
  if (rawApiValue) {
    const formatted = datePipe.transform(rawApiValue.toString(), 'yyyy-MM-dd');
    if (current === formatted) {
      const raw = rawApiValue.toString();
      return new Date(raw.includes('T') && !raw.endsWith('Z') ? raw + 'Z' : raw).getTime();
    }
  }
  return new Date(current).getTime() + NOON_UTC_OFFSET_MS;
}
